import React from 'react'
import useSyntaxHighlighting from '@/lib/hooks/useSyntaxHighlighting'

interface CodeBlockProps {
  code: string
  language?: string
  filename?: string
  highlightedLines?: number[]
}

/**
 * Enhanced code block component with syntax highlighting and line highlighting
 */
const CodeBlock: React.FC<CodeBlockProps> = ({
  code,
  language = 'text',
  filename,
  highlightedLines = [],
}) => {
  // Use our custom hook for syntax highlighting
  useSyntaxHighlighting([code, language])

  // Process code to add line highlighting
  const processedCode = code
    .split('\n')
    .map((line, i) => {
      const lineNumber = i + 1
      const isHighlighted = highlightedLines.includes(lineNumber)
      return isHighlighted ? `<span class="highlight-line">${line}</span>` : line
    })
    .join('\n')

  return (
    <div className="code-block my-6 rounded-md overflow-hidden">
      {filename && (
        <div className="bg-gray-700 px-4 py-2 text-sm text-gray-200 font-mono border-b border-gray-600 flex justify-between items-center">
          <span>{filename}</span>
          <span className="text-xs text-gray-400">{language}</span>
        </div>
      )}
      <pre className={`language-${language} !m-0 relative`}>
        <code
          className={`language-${language}`}
          dangerouslySetInnerHTML={{ __html: processedCode }}
        />
      </pre>
      {!filename && (
        <div className="bg-gray-700 px-4 py-1 text-xs text-gray-400 text-right">{language}</div>
      )}
    </div>
  )
}

export default CodeBlock
